import { NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  DisplayValidationErrorsContainerDirective,
  DisplayValidationErrorsDirective,
  IAccessRouteForm,
  IRoadConditionsForm,
} from '@curbnturf/form-helpers';
import { RoadConditionsComponent } from '../road-conditions/road-conditions.component';

@Component({
  selector: 'curbnturf-rv-requirements',
  templateUrl: './rv-requirements.component.html',
  styleUrls: ['./rv-requirements.component.scss'],
  standalone: true,
  imports: [
    DisplayValidationErrorsContainerDirective,
    DisplayValidationErrorsDirective,
    FormsModule,
    NgIf,
    ReactiveFormsModule,
    RoadConditionsComponent,
  ],
})
export class RvRequirementsComponent {
  @Input() accessRoute: FormGroup<IAccessRouteForm>;

  get roadCondition() {
    if (this.accessRoute) {
      return this.accessRoute.get('roadCondition') as FormGroup<IRoadConditionsForm>;
    }

    return;
  }
  get maxHeight() {
    if (this.accessRoute) {
      return this.accessRoute.get('maxHeight');
    }

    return;
  }

  get maxWidth() {
    if (this.accessRoute) {
      return this.accessRoute.get('maxWidth');
    }

    return;
  }

  get maxLength() {
    if (this.accessRoute) {
      return this.accessRoute.get('maxLength');
    }

    return;
  }

  get minClearance() {
    if (this.accessRoute) {
      return this.accessRoute.get('minClearance');
    }

    return;
  }
}
